import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Twitter,
    href: "https://x.com/quotient",
    label: "X"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com/company/quotient",
    label: "LinkedIn"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }];
  const columns = [{
    title: "Platform",
    links: [{
      label: "qOS Overview",
      href: "/QOSByQuotientPage"
    }, {
      label: "Security",
      href: "#"
    }, {
      label: "Deployment",
      href: "#"
    }, {
      label: "Workflows",
      href: "#"
    }]
  }, {
    title: "Company",
    links: [{
      label: "About Quotient",
      href: "#"
    }, {
      label: "Careers",
      href: "#"
    }, {
      label: "Press",
      href: "#"
    }, {
      label: "News",
      href: "#"
    }]
  }, {
    title: "Legal",
    links: [{
      label: "Privacy Policy",
      href: "#"
    }, {
      label: "Terms of Service",
      href: "#"
    }, {
      label: "Cookie Policy",
      href: "#"
    }, {
      label: "Security Compliance",
      href: "#"
    }]
  }, {
    title: "Support",
    links: [{
      label: "Documentation",
      href: "#"
    }, {
      label: "API Reference",
      href: "#"
    }, {
      label: "System Status",
      href: "#"
    }, {
      label: "Contact Support",
      href: "#"
    }]
  }];
  const marqueeText = "QUOTIENT TECHNOLOGY • qOS • ".repeat(20);
  return <section data-section-id="22935" id="footer" className="dark bg-background text-foreground pt-16 pb-8 overflow-hidden">
      <style>{`
        @keyframes scroll-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: scroll-left 60s linear infinite;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-16">
          <Link to="/QOSByQuotientPage" className="block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605362/img/image_8jv31ngh.png" alt="Quotient Technology" className="h-6 w-auto object-contain grayscale opacity-60 hover:opacity-100 transition-opacity" />
          </Link>

          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Button key={i} data-index={i} variant="ghost" size="icon" asChild className="rounded-md hover:bg-accent hover:text-primary h-10 w-10 text-muted-foreground/60">
                  <Link to={social.href} aria-label={social.label} newTab>
                    <Icon className="!size-5" />
                  </Link>
                </Button>;
          })}
          </div>
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {columns.map((col, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
              <h3 className="text-xs font-bold uppercase tracking-widest text-primary/80">
                {col.title}
              </h3>
              <ul className="flex flex-col gap-3">
                {col.links.map((link, j) => <li key={j} data-index={j}>
                    <Link to={link.href} className="text-muted-foreground/60 hover:text-primary transition-colors text-xs font-mono">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>

      {}
      <div className="relative w-full py-6 overflow-hidden border-y border-border/10 bg-background/30 backdrop-blur-md mb-8">
        <div className="whitespace-nowrap flex animate-marquee w-max">
          <span className="text-[3rem] md:text-[5rem] font-black uppercase tracking-tighter leading-none text-foreground/[0.03] select-none font-mono">
            {marqueeText}
          </span>
          <span className="text-[3rem] md:text-[5rem] font-black uppercase tracking-tighter leading-none text-foreground/[0.03] select-none font-mono">
            {marqueeText}
          </span>
        </div>
      </div>

      {}
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-widest text-muted-foreground/40 border-t border-border/5 pt-8">
          <p>© {currentYear} Quotient Technology Inc. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </section>;
}